import request from '../utils'

const curveApi = {
    curveList: async (modelingId) => {
        const req = request.get(`/api/modeling/${modelingId}/curve`)
        const res = await req;
        return res.body;
    }, 
    curveDetail: async (modelingId, curve) => {
        const req = request.get(`/api/modeling/${modelingId}/curve/${curve}`)
        const res = await req;
        return res.body;
    },
    curveUpdate: async (modelingId, curve) => {
        const req = request.put(`/api/modeling/${modelingId}/curve/${curve.id}`).send(curve);
        const res = await req;
        return res.body;
    },
    curveCreate: async (modelingId, curve) => {
        const req = request.post(`/api/modeling/${modelingId}/curve`).send(curve);
        const res = await req;
        return res.body;
    },
    curveDelete: async (modelingId, curveId) => {
        const req = request.delete(`/api/modeling/${modelingId}/curve/${curveId}/force`);
        await req;
    }
};

export default curveApi